"use strict";

window.APP = window.APP || {};

APP.LanguageSelectionView = Backbone.View.extend({
  template: _.template($("#languageSelectionTemplate").html()),

  events: {
    "click .language-selection__button": "selectLanguage"
  },

  render: function () {
    this.$el.html(this.template({}));
    return this;
  },

  selectLanguage: function (e) {
    e.preventDefault();
    const lang = $(e.currentTarget).data("lang");
    
    // Guardar idioma en localStorage
    localStorage.setItem("language", lang);
    
    // Actualizar atributo data-lang en body para aplicar estilos CSS
    document.body.setAttribute("data-lang", lang);
    
    console.log("Language selected:", lang);
    
    // Navegar a la pantalla de inicio
    if (window.app) {
      window.app.navigate("inicio", { trigger: true });
    }
  }
});
